import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerSvg = styled.svg`
  animation: ${spin} 1s linear infinite;
`;

interface LoadingSpinnerProps {
  className?: string;
  size?: string | number;
  color?: string;
}

export const LoadingSpinner = ({ className, size = '20px', color }: LoadingSpinnerProps) => (
  <SpinnerSvg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ width: size, height: size, color }}
  >
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" opacity="0.25"></circle>
    <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  </SpinnerSvg>
);

export default LoadingSpinner;
